/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Box, Modal, IconButton, SxProps } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface ModalFirmarMiFielsProps {
  widgetIds: string[];
  handleClose: () => void;
  handleSuccess: () => void;
}

const sxModal: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1280px",
  maxWidth: "90%",
  height: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "24px",
};

const ModalFirmarMiFiel: React.FC<ModalFirmarMiFielsProps> = ({ widgetIds, handleClose, handleSuccess }) => {
  const [modalHeight, setModalHeight] = useState<string>("120px");
  const [modalWidth, setModalWidth] = useState<string>("50%");

  const handleSingMifiel = () => {
    setModalHeight("90%");
    setModalWidth("90%");

    window.mifiel.widget({
      widgetId: widgetIds,
      appendTo: "mifiel-widget",
      successBtnText: "Finalizar",
      onLoad: {
        callToAction: function () {
          console.log("loaded");
        },
      },
      onSuccess: {
        callToAction: function () {
          console.log("success");
          handleSuccess();
        },
      },
      onError: {
        callToAction: function () {
          console.log("error");
          handleClose();
        },
      },
    });
  };

  useEffect(() => {
    handleSingMifiel();
  }, [handleSingMifiel, widgetIds]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={true}
      onClose={handleClose}
      closeAfterTransition
    >
      <Box
        sx={{
          ...sxModal,
          maxWidth: "90%",
          width: modalWidth,
          height: modalHeight,
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box id="mifiel-widget"></Box>
      </Box>
    </Modal>
  );
};

export default ModalFirmarMiFiel;
